import React from 'react';
import { Textarea, ExpandableSection, Badge, Spinner } from 'AWS-UI-Components-React';
import { stepFailed, stepPassed, scenarioFailed } from './utils';
import { TEST_RESULT, TEST_RESULT_COLORS, TEST_RESULT_TRANSITION_TIMEOUT } from './constants';

/**
 * Renders test results for a single 'feature'.
 * A 'feature' is analogous to a Cucumber feature.
 * It has the following structure -
 * {
 *  feature: { name }
 *  scenarios: [ {scenarioName, steps} ]
 * }
 *
 * A 'scenario' is a particular case (defined by parameters) for a feature.
 * Example - suppose a feature should be valid for marketplaces US and CA.
 * So this feature will have two scenarios - one for US and one for CA.
 *
 * Steps are each step of the test case (i.e. Given, When, Then, etc.) and
 * provide details at which step the test case failed and why.
 */
export class ViewResultsForFeature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStatusByScenario: {},
    };
  }

  onStepsExpansionChange = (event, scenario) => {
    const scenarioStepsLoaded = scenario.steps && scenario.steps.length;
    if (!scenarioStepsLoaded) {
      this.setLoadingStatus(scenario, true);
      const { loadValidationTestResults } = this.props;
      loadValidationTestResults(scenario, this.resetLoadingStatus(scenario));
    }
  };

  setLoadingStatus = (scenario, value) => {
    this.setState({
      loadingStatusByScenario: { ...this.state.loadingStatusByScenario, [scenario.scenarioName]: value },
    });
  };

  resetLoadingStatus = (scenario) => {
    setTimeout(() => this.setLoadingStatus(scenario, false), TEST_RESULT_TRANSITION_TIMEOUT);
  };

  getScenarioHeader = (scenario) => {
    const failed = scenarioFailed(scenario);
    const scenarioStepsLoaded = scenario.steps && scenario.steps.length;
    const { loadingStatusByScenario } = this.state;
    const spinner = !scenarioStepsLoaded && loadingStatusByScenario[scenario.scenarioName] ? <Spinner /> : '';
    return (
      <div style={{ color: failed ? TEST_RESULT_COLORS.FAIL : TEST_RESULT_COLORS.PASS }}>
        {spinner}
        {scenario.scenarioName}
      </div>
    );
  };

  render() {
    const { testResultForFeature } = this.props;
    const { result, scenarios, feature } = testResultForFeature;
    const featureFailed = (result || '').toLowerCase() !== TEST_RESULT.PASS;
    const highlightColor = featureFailed ? TEST_RESULT_COLORS.FAIL : TEST_RESULT_COLORS.PASS;

    return (
      <div>
        <ExpandableSection
          header={
            <div style={{ color: highlightColor }}>
              {feature.name} {featureFailed && <Badge color={highlightColor} content={'Failed'} />}
            </div>
          }
        >
          <div>
            {scenarios.map((scenario) => (
              <div className="awsui-util-container" key={scenario.scenarioName}>
                <ExpandableSection
                  header={this.getScenarioHeader(scenario)}
                  onChange={(event) => this.onStepsExpansionChange(event, scenario)}
                >
                  <div className="awsui-util-container">
                    {scenario.steps.map((step) => {
                      const hasStepFailed = stepFailed(step);
                      const hasStepPassed = !hasStepFailed && stepPassed(step); // Step status can be pass,fail or ignored
                      return (
                        <ExpandableSection
                          variant="borderless"
                          header={
                            <span
                              style={{
                                color: hasStepFailed
                                  ? TEST_RESULT_COLORS.FAIL
                                  : hasStepPassed
                                  ? TEST_RESULT_COLORS.PASS
                                  : '',
                              }}
                            >{`${step.name}`}</span>
                          }
                          key={step.name}
                          expanded={
                            hasStepFailed && !Boolean(this.state.loadingStatusByScenario[scenario.scenarioName])
                          }
                        >
                          <div>Result: {step.result}</div>
                          {hasStepFailed && (
                            <div>
                              Message: {step.message ? <Textarea value={step.message} disabled={true} /> : 'none'}
                            </div>
                          )}
                        </ExpandableSection>
                      );
                    })}
                  </div>
                </ExpandableSection>
              </div>
            ))}
          </div>
        </ExpandableSection>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_for_feature.jsx